import "../styles/display.css";
import Button from "../components/button";
// import scarecrow from "../../../Assets/Scarecrow.png"
import errorimg from "../../../Assets/errorimg.png"
import { Link } from "react-router-dom";

function Display() {
  return (
    <div className="display">
      <div className="display__img">
        <img src={errorimg} alt="404-Scarecrow" />
      </div>
      <div className="display__content">
        <h2 className="display__content--info">Bad news</h2>
        <p className="display__content--text">
          The page you are looking for might be removed or is temporarily
          unavailable
        </p>
        <Link to="/">
        <Button className="btn">Back to homepage</Button>
        </Link>
      </div>
    </div>
  );
}

export default Display;
